import * as React from 'react';
import {
  Select as SelectPrimitive,
  SelectGroup as SelectGroupPrimitive,
  SelectValue as SelectValuePrimitive,
  SelectTrigger as SelectTriggerPrimitive,
  SelectContent as SelectContentPrimitive,
  SelectLabel as SelectLabelPrimitive,
  SelectItem as SelectItemPrimitive,
  SelectSeparator as SelectSeparatorPrimitive,
  SelectScrollUpButton as SelectScrollUpButtonPrimitive,
  SelectScrollDownButton as SelectScrollDownButtonPrimitive,
} from '@/features/ui/primitives/select';
import { cn } from '@/lib/utils';

const Select = SelectPrimitive;
const SelectGroup = SelectGroupPrimitive;
const SelectValue = SelectValuePrimitive;
const SelectContent = SelectContentPrimitive;
const SelectLabel = SelectLabelPrimitive;
const SelectItem = SelectItemPrimitive;
const SelectSeparator = SelectSeparatorPrimitive;
const SelectScrollUpButton = SelectScrollUpButtonPrimitive;
const SelectScrollDownButton = SelectScrollDownButtonPrimitive;

const SelectTrigger = React.forwardRef<
  React.ElementRef<typeof SelectTriggerPrimitive>,
  React.ComponentPropsWithoutRef<typeof SelectTriggerPrimitive>
>(({ className, ...props }, ref) => (
  <SelectTriggerPrimitive
    ref={ref}
    className={cn(
      'h-9 focus:ring-2 focus:ring-blue-500 px-3 [&>svg]:hidden md:[&>svg]:block',
      className
    )}
    {...props}
  />
));
SelectTrigger.displayName = SelectTriggerPrimitive.displayName;

export {
  Select,
  SelectGroup,
  SelectValue,
  SelectTrigger,
  SelectContent,
  SelectLabel,
  SelectItem,
  SelectSeparator,
  SelectScrollUpButton,
  SelectScrollDownButton,
};
